module.exports = __webpack_public_path__ + "static/television-cb58021d2e9326a749c251ef49166377.jpg";